import { ContactForm } from '@/types/contact-form'

export const sendContactForm = async (form: ContactForm) => {
  const res = await fetch(`/api/contact-form`, { method: 'POST', body: JSON.stringify(form) })
  if (!res.ok) throw Error()
}
